import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';

import { AdminObjectBadge } from '../../../components/admin-object-badge/admin-object-badge.component';
import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { UpdateGroupModal } from './update-group-modal/update-group-modal.component';
import { useUserGroupCard } from './user-group-card.controller';

export interface UserGroupCardProps {
    entity_id: string;
}

const USER_GROUP_MODAL_ID = 'user-group-modal';

export const UserGroupCard = (props: UserGroupCardProps) => {
    const viewProps = useUserGroupCard(props);

    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.GROUP.PLURAL}
            content={
                <div className='flex flex-wrap gap-2'>
                    {viewProps.groups.map((group) => (
                        <AdminObjectBadge
                            key={group.id}
                            entityType={EntityType.USER_GROUP}
                            id={group.id}
                        />
                    ))}
                </div>
            }
            update={{
                onUpdate: () =>
                    viewProps.openModal(USER_GROUP_MODAL_ID, () => (
                        <UpdateGroupModal
                            groups={viewProps.groups}
                            members={viewProps.members}
                            entity_id={props.entity_id}
                            callback={() => viewProps.fetchGroups()}
                        />
                    ))
            }}
        />
    );
};
